import { IoIosInformationCircleOutline } from 'react-icons/io';
import { IoChevronUp, IoChevronDown } from 'react-icons/io5';

import { CustomNodeHeaderProps } from 'types';
import { NodeButtonView, NodeExpandButton, NodeHeader, NodeIcon, NodeNameView } from '../../ui';

const ModelNodeHeader = ({ data, onExpandClick }: CustomNodeHeaderProps) => {
  return (
    <NodeHeader>
      <NodeNameView>
        {data.subCategory === 'HuggingFace(for NLP)' && (
          <NodeIcon>
            <img
              src={`${process.env.PUBLIC_URL}/assets/svgs/huggingface_logo-noborder.svg`}
              alt={data.name}
              style={{ width: '20px' }}
            />
          </NodeIcon>
        )}
        <span>{data.name}</span>
      </NodeNameView>
      <NodeButtonView>
        <a href={data.link} target="_blank" rel="noopener noreferrer">
          <IoIosInformationCircleOutline />
        </a>
        <NodeExpandButton onClick={onExpandClick}>{data.expand ? <IoChevronUp /> : <IoChevronDown />}</NodeExpandButton>
      </NodeButtonView>
    </NodeHeader>
  );
};

export default ModelNodeHeader;
